module.exports = __webpack_public_path__ + "static/media/Ball-Pen-Regular.f90c0575.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Ball-Pen-Regular.otf
// module id = 1673
// module chunks = 46